export default __webpack_public_path__ + "static/media/CarIcon.71b26c6b.svg";